import styled from "styled-components";
import { Container, Segment } from "semantic-ui-react";

export const SemanticContainer = styled.div`
  margin: 1rem;
  padding: 1rem !important;
  max-width: 100%;
  width: 100%;
`;

export const SemanticSegment = styled(Segment)`
  text-align: center;
  position: relative;
  bottom: 0;
`;
